import { Box, Typography, Button } from "@mui/material";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

// CONAS Brand Colors
const CONAS_BLUE = "#163672";

function PaginationView({ currentPage, PrevButtonClick, NextButtonClick, totalDataCount, setCurrentPage }) {
    const pages = [];

    if (totalDataCount <= 7) {
        for (let i = 1; i <= totalDataCount; i++) pages.push(i);
    } else {
        pages.push(1);
        if (currentPage > 4) pages.push("...");
        const start = Math.max(2, currentPage - 1);
        const end = Math.min(totalDataCount - 1, currentPage + 1);
        for (let i = start; i <= end; i++) pages.push(i);
        if (currentPage < totalDataCount - 3) pages.push("...");
        pages.push(totalDataCount);
    }

    if (totalDataCount <= 1) return null; // Hide if only 1 page

    return (
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 3, pt: 3, pb: 2 }}>
            
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                
                {/* Prev Button */}
                <Button 
                    variant="outlined" 
                    disabled={currentPage <= 1} 
                    onClick={PrevButtonClick}
                    startIcon={<ChevronLeftIcon />}
                    sx={{ color: "#475569", borderColor: "#e2e8f0", bgcolor: "#fff", borderRadius: "8px", textTransform: "none", fontWeight: 600, minWidth: "80px" }}
                >
                    Prev
                </Button>

                {/* Page Numbers */}
                <Box sx={{ display: "flex", gap: 0.5 }}>
                    {pages.map((page, index) => {
                        const isDots = page === "...";
                        const isActive = page === currentPage;

                        return (
                            <Box 
                                key={index} 
                                onClick={() => !isDots && setCurrentPage(page)} 
                                sx={{ 
                                    width: "36px", 
                                    height: "36px", 
                                    display: "flex", 
                                    alignItems: "center", 
                                    justifyContent: "center",
                                    borderRadius: "8px", 
                                    cursor: isDots ? "default" : "pointer",
                                    bgcolor: isActive ? CONAS_BLUE : "#ffffff",
                                    border: isDots ? "none" : (isActive ? `1px solid ${CONAS_BLUE}` : "1px solid #e2e8f0"),
                                    color: isActive ? "#ffffff" : "#475569",
                                    fontWeight: isActive ? 700 : 500,
                                    fontSize: "0.9rem",
                                    transition: "all 0.2s ease",
                                    "&:hover": {
                                        bgcolor: isDots ? "transparent" : (isActive ? "#112a59" : "#f8fafc") // Darker navy hover for active
                                    }
                                }}
                            >
                                {page}
                            </Box>
                        )
                    })}
                </Box>

                {/* Next Button */}
                <Button 
                    variant="outlined" 
                    disabled={currentPage >= totalDataCount} 
                    onClick={NextButtonClick}
                    endIcon={<ChevronRightIcon />}
                    sx={{ color: "#475569", borderColor: "#e2e8f0", bgcolor: "#fff", borderRadius: "8px", textTransform: "none", fontWeight: 600, minWidth: "80px" }}
                >
                    Next
                </Button>
            </Box>

            {/* Page Count Text on the right */}
            <Typography variant="body2" sx={{ color: "#475569", fontWeight: 500 }}>
                Page {currentPage} of {totalDataCount}
            </Typography>

        </Box>
    )
}

export default PaginationView;